<main role="main" class="page-Chantiers-infrastructures not-home-page">
    <div class="container">
      <div class="row">
        <div class="col-md-12 index-up">
          <app-breadcrumb></app-breadcrumb>
          <h2>Gestion Access</h2>
          <p class="text-primary size18 font-weight-semibold">
            Gestion Access
          </p>
        </div>
      </div>
    </div>
      <section class="c-appels-offres">
        <div class="container">
          <form class="form-ap" action="" method="get">
            <div class="form-row">
              <div class="col-md-3">
                <label for="categorie">Numéro d'autorisation</label>
                <input #nbrautorisation class="form-control" id="nbrautorisation" type="text" placeholder="Saisissez le numéro d'autorisation">
              </div>
            </div>
            <button (click)="lancer(nbrautorisation.value)" class="btn btn-info pr-5"  style="right:20%" type="submit">Lancer la recherche<span class="icon-search"></span></button>
          </form>
        </div>
    </section>
    <section class="results-appels-offres">
      <div class="container" style="min-height: 6px;">
        <div class="row">
          <div >
            <h2 *ngIf="res" class="col d-flex justify-content-between" class="size18">Résultat de recherche : </h2>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive">
            <table class="table table-bordered">
                <tr *ngIf="res.Title != ''" class="thead-light">
                  <th colspan="2" class="text-center">{{res.Title}}</th>
                </tr>
                <tr *ngIf="res.Msg != ''" class="thead-light">
                  <td  class="text-center">{{res.Msg}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th colspan="2" class="text-center">
                    <a download="pdfTitle" [href]="'data:application/pdf;base64,'+res.url" title='télecharger le document'>télecharger le document</a>
                  </th>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Nom et Prenom</th>
                  <td class="text-center">{{res.data.nomPrenom}}</td>
                </tr>
                <!-- <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">CIN</th>
                  <td class="text-center">{{res.data.cin}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Date Debut</th>
                  <td class="text-center">{{res.data.dateDebut}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Date Fin</th>
                  <td class="text-center">{{res.data.dateFin}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Date Validation</th>
                  <td class="text-center">{{res.data.dateValidation}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Etat Badge</th>
                  <td class="text-center">{{res.data.etatBadge}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">lastDateEntree</th>
                  <td class="text-center">{{res.data.lastDateEntree}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Numero de la Demande</th>
                  <td class="text-center">{{res.data.numDemande}}</td>
                </tr> -->
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Port</th>
                  <td class="text-center">{{res.data.port}}</td>
                </tr>
                <!-- <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">Statut</th>
                  <td class="text-center">{{res.data.statut}}</td>
                </tr> -->
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th class="text-center">typeAcces</th>
                  <td class="text-center">{{res.data.typeAcces}}</td>
                </tr>
                <tr *ngIf="res.data!=null" class="thead-light">
                  <th style=" vertical-align: middle;" class="text-center">zones</th>
                  <td class="text-center">
                    <span *ngFor="let zone of res.data.zones" style="padding: 5px;margin: 5px;" class="card">{{zone.libelle}}</span>
                  </td>
                </tr>
            </table>
          </div>
        </div>
      </div>
    </section>
  </main>